import clsx from "clsx";

import styles from "@/components/ui/DatePicker/Controls/Controls.module.css";
import Icon from "@/components/ui-deprecated/Icon/Icon";

type Props = {
    onClick: () => void;
    disabled?: boolean;
};

const ControlsNext = (props: Props) => {
    return (
        <button
            className={clsx(styles.control, styles.controlStep, styles.controlStepNext)}
            onClick={props.onClick}
            disabled={props.disabled}
            type="button"
        >
            <Icon icon={"angle-right"} />
        </button>
    );
};

export { ControlsNext };
